module.exports = __webpack_public_path__ + "img/Blog-Image@3x.698c6645.png";